module.exports = __webpack_public_path__ + "img/74ae5a6.png";